import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ReducerConstants from '../../../_shared/constants/reducers';
import { TradeDetails } from './state';

const setTradeDetails = (state, action: PayloadAction<TradeDetails>) => ({
  ...state,
  ...action.payload
});

const setUpcomingProxy = (state, action) => ({
  ...state,
  details: {
    ...state.details,
    upcomingProxy: {
      ...state.details.upcomingProxy,
      ...action.payload
    }
  }
});

const setActiveProxy = (state, action) => ({
  ...state,
  auctionSummary: {
    ...state.auctionSummary,
    ...action.payload
  }
});

export const initialState = {};

export const tradeDetailsSlice = createSlice({
  name: ReducerConstants.TRADE_DETAILS,
  initialState,
  reducers: {
    setTradeDetails,
    setUpcomingProxy,
    setActiveProxy
  }
});

export default tradeDetailsSlice.reducer;
